import React, { useEffect } from 'react'
import Dropdown from '../../../../Components/Dropdown/Dropdown';
import Stepper from '../../../../Components/Stepper/Stepper';
import { Button, Input, Textarea } from '../../../../Components/StyledComponents';
import './CreateOptionGroup.scss';
import {cloneDeep} from 'lodash-es';
import { support_language } from '../../../../Utils/services';
import { useSelector } from 'react-redux';
import { languageInit, onTranslation } from '../../../../Utils/functions';
import CheckLanguage from '../../../../Components/TableOrder/CheckLanguage';

const ModifyOptionGroup = ({info,patchOptionGroup}) => {
    const [ step, setStep ] = React.useState(1)
    const [ name, setName ] = React.useState({})
    const [ desc, setDesc ] = React.useState({})
    const [ options, setOptions ] = React.useState([{ Name : languageInit(), Price : 0 , Description : languageInit() }])
    const [ isRequire, setIsRequire ] = React.useState(true)
    const [ selectableCount, setSelectableCount ] = React.useState({ Min : 1, Max : 1 })
    const language = useSelector(state => state.tableorder.language)

    const [ is_load, setIsLoad ] = React.useState(false);
    const [ force_update, setForceUpdate ] = React.useState(false);

    useEffect(() => {
        setName(cloneDeep(info.Name));
        setDesc(cloneDeep(info.Description));
        setOptions(cloneDeep(info.OptionInfo));
        setIsRequire(cloneDeep(info.isRequire));
        setSelectableCount(cloneDeep(info.SelectableCount));
        setIsLoad(true);
    },[])

    useEffect(() => {
        if(is_load) {
            let arr = selectableCount;
            if( isRequire ) arr.Min = 1;
            else arr.Min = 0
            setSelectableCount(arr);
            setForceUpdate(!force_update)
        }
    },[isRequire])

    const nextStep = () => {
        if(step !== 4) setStep(old => old+1)
        else patch()
    }

    const getOptions = () => {
        let arr = []

        for(let i=0; i<info.OptionIds.length; i++){
            arr.push({ key : i+1 + '개', value : i+1 })
        }

        return arr;
    }

    const patch = () => {
        let arr = [];
        for(let i=0; i<options.length;i++){
            arr.push({ Name : options[i].Name, Price : parseInt(options[i].Price), Description : options[i].Description })
        }
        patchOptionGroup({
            GroupId : info._id.$oid,
            Name : name,
            Description : desc,
            isRequire : isRequire,
            SelectableCount : {
                Min : parseInt(selectableCount.Min),
                Max : parseInt(selectableCount.Max)
            }
        })
    }

    const isDisabled = () => {
        if(step === 1 && name.ko?.trim() === '' ) return true
        else if( step === 2 && ( options.length === 0 || options[0].Name.ko?.trim() === '' )) return true
        else return false
    }
    const translationBtn = async () => {
        const trans_language = Object.entries(language).map(([key, value]) => value === true && key).filter(item => item !== false);
        const trans_data = [name.ko, desc.ko, ...options.map(item => item.Name.ko)];
        const trans_value = ['name', 'desc', ...options.map((item, index) => ({value: 'options', index: index, key: 'Name', data: item}))];
        const data = await onTranslation(trans_language, trans_data, trans_value);
        setName({...data.name});
        setDesc({...data.desc});
        setOptions([...data.options]);
    };
    return (
        <div className='create-option-group'>
            <Stepper maxStep={4} step={step} containerStyle={{ marginBottom : step === 3 ? 0 : 40 }}/>
            {
                step === 4 && <p className="warn-text">모두 입력되었어요. 마지막으로 확인해주세요.</p>
            }
            {
                step === 1 &&
                <>
                    <div className='row'>
                        <p className='label'>옵션그룹명</p>
                        <Input
                            value={name.ko}
                            onChange={(e) => setName({...name, ko: e.target.value})}
                            style={{ width : 347 }}
                            placeholder="예) 맛선택, 사이드메뉴 추가 등"
                        />
                    </div>

                    <div className='row' style={{ alignItems : 'flex-start', marginTop : 16 }}>
                        <p className='label'>설명(선택)</p>
                        <Textarea
                            value={desc.ko}
                            onChange={(e) => setDesc({...desc, ko: e.target.value})}
                            style={{ width : 347, height : 173 }}
                            placeholder="예) 추가 옵션입니다 (1개 이상 필수)"
                        />
                    </div>
                </>
            }
            {step === 2 && 
                <>
                    <CheckLanguage>
                        <div className='btn-row' style={{margin:0, alignItems:'center'}}>
                            <p className='label' style={{flex:1, textAlign:'right', margin: 0, marginRight: 8, color:'#f95f53'}} >서비스 준비 중입니다.</p>
                            <Button variant="sub" small className='save-btn' fontSize={16} onClick={translationBtn} disabled={true || name.ko === '' || typeof name.ko === 'undefined'}>
                                자동번역
                            </Button>
                        </div>
                        {support_language.map((item, index) => {
                            if(language[item.value]){
                                return (
                                    <React.Fragment key={index}>
                                        {index !== 0 && <div className='divider' style={{margin: '24px 0'}} />}
                                        <p className='title' style={{margin:0}}>{item.text}</p>
                                        <div className='row'>
                                            <p className='label'>옵션그룹명</p>
                                            <Input
                                                value={name[item.value]}
                                                onChange={(e) => setName({...name, [item.value]: e.target.value})}
                                                style={{ width : 347 }}
                                                placeholder="예) 맛선택, 사이드메뉴 추가 등"
                                            />
                                        </div>

                                        <div className='row' style={{ alignItems : 'flex-start', marginTop : 16, marginBottom: 32 }}>
                                            <p className='label'>설명(선택)</p>
                                            <Textarea
                                                value={desc[item.value]}
                                                onChange={(e) => setDesc({...desc, [item.value]: e.target.value})}
                                                style={{ width : 347, height : 173 }}
                                                placeholder="예) 추가 옵션입니다 (1개 이상 필수)"
                                            />
                                        </div>
                                    </React.Fragment>
                                )
                            }
                        })}
                    </CheckLanguage>
                </>
            }

            {
                step === 3 &&
                <>
                    <p className='label'>옵션정보</p>
                    <div className='row' style={{ marginTop : 16 }}>
                        <button className={`${ isRequire ? 'selected-btn' : 'unselected-btn'}`} style={{ marginRight : 32, width : 180 }} onClick={() => setIsRequire(true)}>
                            <div className='row' style={{ justifyContent : 'center' }}>
                                {
                                    isRequire ?
                                    <img src={require('../../../../aseets/icons/check.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                    :
                                    <img src={require('../../../../aseets/icons/check_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                }
                                옵션 선택시 주문가능
                            </div>
                        </button>

                        <button className={`${ !isRequire ? 'selected-btn' : 'unselected-btn'}`} style={{ width : 232 }} onClick={() => setIsRequire(false)}>
                            <div className='row' style={{ justifyContent : 'center' }}>
                                {
                                    isRequire ?
                                    <img src={require('../../../../aseets/icons/close.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                    :
                                    <img src={require('../../../../aseets/icons/close_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                }
                                옵션 선택하지 않아도 주문가능
                            </div>
                        </button>
                    </div>

                    <p className='label' style={{ marginTop : 40 }}>옵션 개수</p>
                    <p className='label' style={{ marginTop : 8, marginBottom : 16, opacity : 0.5, width : 'fit-content' }}>현재 옵션 그룹에는 {options.length}개의 옵션이 있어요.</p>
                    <div className='row'>
                        {
                            isRequire &&
                            <>
                                <p className='drop-text'>최소</p>
                                <Dropdown
                                    width={161}
                                    options={getOptions()}
                                    onItemClick={(val) => setSelectableCount({...selectableCount, Min : val})}
                                    selected={true}
                                    value={selectableCount.Min}
                                    btnStyle={{ marginRight : 16 }}
                                    prefix={'개'}
                                />
                            </>
                        }
                        <p className='drop-text'>최대</p>
                        <Dropdown
                            width={isRequire ? 161:379}
                            options={getOptions()}
                            onItemClick={(val) => setSelectableCount({...selectableCount, Max : val})}
                            selected={true}
                            value={selectableCount.Max}
                            prefix={'개'}
                        />
                    </div>
                </>
            }
            
            {
                step === 4 &&
                <>
                    <div>
                        
                        <p className="label" style={{ marginTop : 16 }}>옵션 그룹명</p>
                        <p className="text">{name.ko}</p>
                        <p className="label" style={{ marginTop : 16 }}>설명</p>
                            <p className="text">{desc.ko}</p>
                        <div className="divider" style={{ margin : 0 }} />
                        {support_language.map(item => language[item.value] && 
                            <>
                                <p className="title" style={{marginTop : 16, marginBottom: 0}}>{item.text}</p>
                                <p className="label" style={{ marginTop : 16 }}>옵션 그룹명</p>
                                <p className="text">{name[item.value]}</p>
                                <p className="label" style={{ marginTop : 16 }}>설명</p>
                                    <p className="text">{desc[item.value]}</p>
                                <div className="divider" style={{ margin : 0 }} />
                            </>
                        )}

                        <p className="label" style={{ marginTop : 16 }}>옵션 개수</p>
                        <p className="text">{isRequire ? `최소 ${selectableCount.Min}개 ` : ''} 최대 {selectableCount.Max}개</p>
                    </div>
                </>
            }
            

            <div className='btn-row'>
                {
                    step !== 1 &&
                    <Button variant="outline" className='save-btn' fontSize={16} onClick={() => setStep(old => old -1)} style={{ marginRight : 24 }}>
                        이전
                    </Button>
                }
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => nextStep()} disabled={isDisabled()}>
                    {step === 4 ? '수정하기' : '다음'}
                </Button>
            </div>
        </div>
    )
}

export default ModifyOptionGroup;